export default function getUserName(userList, userId) {
  for (let i = 0; i < userList.length; i++) {
    if (userList[i].id === userId) {
      return userList[i].name;
    }
  }
  return null;
}
